import { Box, Button, Typography } from "@mui/material";
import { useMemo } from "react";

import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import SimpleDataTable from "../../../../components/simpleDataTable";
import { IDescontoAdicionalCampanha } from "../../../../interfaces/ICampanhaComercial";

interface IProps {
    numeroCampanha: number | null;
    nomeCampanha: string | null;
    descontos: IDescontoAdicionalCampanha[];
    onClose: () => void;
}

export default function DialogDescontos({ numeroCampanha, nomeCampanha, descontos, onClose }: IProps) {
    const columns = useMemo(
        () => [
            {
                headerName: "Nº Campanha",
                field: "numeroCampanha",
                type: "number",
                headerAlign: "left",
                width: 120,
            },
            {
                headerName: "Cód. Tipo Título",
                field: "codTipTit",
                type: "number",
                headerAlign: "left",
                width: 150,
            },
            {
                headerName: "% Desconto Adicional",
                field: "percentualDescontoAdicional",
                type: "number",
                headerAlign: "left",
                width: 180,
                valueFormatter: ({ value }: any) => (value != null ? `${value}%` : "-"),
            },
            {
                headerName: "Valor Desconto Adicional",
                field: "valorDescontoAdicional",
                type: "number",
                headerAlign: "left",
                width: 200,
                valueFormatter: ({ value }: any) =>
                    value != null
                        ? value.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })
                        : "-",
            },
        ],
        []
    );

    return (
        <Dialog
            maxWidth="md"
            fullWidth
            onClose={(_, reason) => {
                if (reason !== "backdropClick") {
                    onClose();
                }
            }}
            open
        >
            <DialogTitle>
                Descontos Adicionais
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
                <Typography variant="body2" sx={{ mb: 2 }}>
                    Campanha <strong>{numeroCampanha}</strong>
                    {nomeCampanha ? ` — ${nomeCampanha}` : ""}
                </Typography>
                <Box sx={{ height: Math.max(200, Math.min(descontos.length * 52 + 56, 500)) }}>
                    <SimpleDataTable
                        columns={columns}
                        rows={descontos}
                        rowId={(row: IDescontoAdicionalCampanha) => row.descontoAdicionalCampanhaId}
                        hideFooter
                    />
                </Box>
            </DialogContent>
            <DialogActions style={{ display: "flex", justifyContent: "center", margin: "16px" }}>
                <Button
                    onClick={onClose}
                    color="warning"
                    variant="contained"
                    style={{ width: "159px", height: "44px" }}
                >
                    Fechar
                </Button>
            </DialogActions>
        </Dialog>
    );
}